

<body>
<div class="example-container" [class.example-is-mobile]="mobileQuery.matches" *ngIf="!shouldRun">
    
    
    <mat-toolbar color="primary" class="example-toolbar">

    
   
      <button mat-icon-button (click)="snav.toggle()"><mat-icon>menu</mat-icon></button>
     
     
      <h1 class="example-app-name">Ms. Nirmalie's ICT Class</h1>

    <div  class="example-button">
     <a mat-raised-button color="warn" routerLink="aboutme" >about me</a>
       </div>
     <div class ="mini">
       <button mat-fab></button>
      </div>
      
        </mat-toolbar>
  
  
     <mat-sidenav-container class="example-sidenav-container"
                           [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
       <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'" 
                   [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
        <mat-nav-list>

          <button mat-raised-button class="plain"  routerLink = "csnotes" >Notes </button>
       
          
          <br><br>
          
          <button mat-raised-button class="plain" routerLink="graph" >Graphs</button>
          
          <br><br>
          <button mat-raised-button class="plain" routerLink="table">Table </button>
          <br><br>
              
       <!--<a mat-raised-button class="plain" color = "primary" href="https://sites.google.com/site/mrsnirmaliesmathclass/" target="_blank">Link</a> -->       
        </mat-nav-list>
      
                       
 
       
      </mat-sidenav>

      <mat-sidenav-content>

        
        <div class="container">
          <div class="row">
            <div class="col-md-4 mx-auto my-3" *ngFor="let card of cards">
              <mat-card>
                                             
               
                <img mat-card-image [src]="card.img" alt="Photo" *ngIf="card.show">
                <div class="show" *ngIf="!card.show">{{card.note}}</div>

                
                
                  <mat-card-title>
                 <!--<h4 class="pong"><a (click)="getRouter(card.path)">{{card.title}}</a></h4>-->
                 <h4 class="pong"><a (click)="getInfo(card)">{{card.title}}</a></h4>
                  
                  </mat-card-title>
        
                  <mat-card-content>
                   
                  </mat-card-content>
                         
              </mat-card>
            </div>
          </div>
        </div>

        <p *ngFor="let content of fillerContent">{{content}}</p>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
  
 

</body>
  

